const endpoints = {
  startPayment: "/api/payment",
  getPaymentByToken: "/api/payment/token",
  getInvoice: "/api/company",
  getPaymentInv:"/api/company",
  postAdvancePay: '/api/company'
};
export { endpoints };
